<template>
    <div>
        <div v-if="fileName" class="flex items-center justify-between border border-[#D0D5DD] rounded-md shadow-md p-4">
            <p class="text-gray-600">
                {{ $t('Fichier sélectionné :') }}
                <span class="font-bold">{{ fileName }}</span>
            </p>
            <button class="text-sm font-medium text-airbus-blue hover:underline" @click.prevent="clearFile">{{ $t('Supprimer') }}</button>
        </div>

        <label v-else :for="name" class="group cursor-pointer flex flex-col items-center border border-[#D0D5DD] rounded-md shadow-md p-4">
            <div class="flex items-center justify-center w-10 h-10 text-white bg-gray-800 border-2 rounded-full">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"></path>
                    <path d="M12 12v9"></path>
                    <path d="m16 16-4-4-4 4"></path>
                </svg>
            </div>

            <span class="text-sm font-bold text-gray-800 group-hover:underline">{{ $t('Cliquez pour télécharger') }}</span>
            <p class="mt-2 text-sm text-gray-700">PDF, WORD, TXT, JPG, PNG (max. 10Mo)</p>
        </label>
        <input ref="inputRef" type="file" :name="name" :id="name" class="hidden" @click="clearFile" @input="updateFile" />
    </div>
</template>

<script setup>
    import Swal from 'sweetalert2';
    import { ref } from 'vue';

    const props = defineProps({
        modelValue: String | null,
        name: String,
    });

    const emit = defineEmits(['update:modelValue']);

    const inputRef = ref(null);
    const fileName = ref('');

    function clearFile() {
        emit('update:modelValue', null);
        fileName.value = '';
        inputRef.value.value = '';
    }

    function updateFile(ev) {
        let file = ev.target.files[0];

        // The file must be either PDF, DOC, DOCX, TXT, JPG or PNG
        if (
            ![
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'text/plain',
                'image/jpeg',
                'image/png',
            ].includes(file.type)
        ) {
            Swal.fire({
                icon: 'error',
                title: 'Fichier invalide',
                text: 'Le fichier doit être au format PDF, WORD, TXT, JPG ou PNG',
            });

            return;
        }

        // The file must be less than 10Mo
        if (file.size > 10 * 1024 * 1024) {
            Swal.fire({
                icon: 'error',
                title: 'Fichier invalide',
                text: 'La taille du fichier doit être de 10Mo ou moins',
            });

            return;
        }

        fileName.value = file.name;

        emit('update:modelValue', file);
    }
</script>
